<template>
    <p>로그아웃중입니다.</p>
</template>
<script>
export default {
    name: "Logout",
    mounted(){
          // this.$store
          //   .dispatch("logout", {})
          //   .then(() => {
          //     this.$router.push("/");
          //   });
          this.$router.push("/");
    }
}
</script>